import styled from 'styled-components';
import { Badge } from '@components/Backoffice/BackofficeLayout.styled';

export const BannedBadge = styled(Badge)`
  margin-left: 8px;
`;
